import { Injectable } from '@angular/core';
import { UntypedFormArray, FormGroup, AbstractControl } from '@angular/forms';

@Injectable()
export class OptService {

  constructor() { }

  //Determine if an LDC's last response has been been synced
  hasLastResponseBeenSynced(transactionType: string, transactionCode: string, currentCode: string, isSynced: boolean): boolean {
    if (transactionType === 'OPTOUT') {
      if (isSynced) {
        return true;
      }
    }
    else {
      if (transactionCode === currentCode && isSynced) {
        return true;
      }
    }
    return false;
  }

  toggleSelectAll(e: any, ldcs: UntypedFormArray, conditionCheck: (control: AbstractControl) => {}) {
    let checkValue = e.target.checked;
    for (let i = 0; i < ldcs.length; i++) {
      if (conditionCheck(ldcs.at(i)) && ldcs.at(i).get('checked').value != checkValue) {
        ldcs.at(i).get('checked').setValue(checkValue);
      }
    }
  }
}
